import React, { useEffect, useRef, useState } from "react";
import Headerbar from "../../../Components/InnerLayout/Headerbar";
import UserInterface from "../../../Components/InnerLayout/UserInterface";
import ModelContainer from "../../../Components/ModelContainer";
import { useDispatch, useSelector } from "react-redux";
import { actions } from "../../../../Redux";
import Select from "../../../Components/Select";
import Input from "../../../Components/Input";
import MultiSelect from "../../../Components/MultiSelect.jsx";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import TimeInput from "../../../Components/TimeInput";
import { editMultiSelectOptions } from "../../../../helpers";

const InventoryCountSettings = (params) => {
  const dispatch = useDispatch();
  const [modalType, setModalType] = useState("add");

  const showAddModal = useSelector(
    (state) => state?.settingReducer.inventory_item_modal_state
  );
  const setShowModal = (modalState) =>
    dispatch(
      actions?.setModalState({
        modalName: "inventory_item_modal_state",
        modalState,
      })
    );

  const InventoryCountSettingData = useSelector(
    (state) => state?.settingReducer?.inventory_count_settings_data
  );

  const InventoryEditCountSettingData = useSelector(
    (state) => state?.settingReducer?.inventory_edit_count_settings_data
  );

  const [generalCountSettings, setGeneralCountSettings] = useState({
    hide_expected_unit_amount: "no",
    pre_fill_count_unit: "yes",
  });

  useEffect(() => {
    setGeneralCountSettings({
      hide_expected_unit_amount:
        InventoryCountSettingData?.general_setting?.hide_expected_unit_amount,
      pre_fill_count_unit:
        InventoryCountSettingData?.general_setting?.pre_fill_count_unit,
    });
  }, [InventoryCountSettingData]);

  useEffect(() => {
    dispatch(actions.getInventoryCountSettingsData());
  }, []);

  return (
    <UserInterface>
      <div className="no-sidebar row" id="content">
        <Headerbar />

        <div className="inner-content row mx-0 finance-setting-chart chart-of-accounts">
          <div className="container px-0">
            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">General Count Settings</h4>
                  <div class="row w-100 mx-0">
                    <div class="col-xl-3 col-md-6 col-12 selection">
                      <ul class="ingredient-info edit-shift">
                        <li>
                          <label>Hide Expected Unit Amount</label>
                          <div class="input-group select-div span7">
                            <select
                              onChange={(e) =>
                                setGeneralCountSettings({
                                  ...generalCountSettings,
                                  hide_expected_unit_amount: e.target.value,
                                })
                              }
                              name="data[InventoryGeneralSetting][hide_expected_unit_amount]"
                              id="InventoryGeneralSettingHideExpectedUnitAmount"
                            >
                              {InventoryCountSettingData?.yes_no?.map((el) => (
                                <option
                                  selected={
                                    generalCountSettings?.hide_expected_unit_amount ===
                                    el?.value
                                  }
                                  value={el.value}
                                >
                                  {el.label}
                                </option>
                              ))}
                            </select>{" "}
                          </div>
                        </li>
                      </ul>
                    </div>
                    <div class="col-xl-3 col-md-6 col-12 selection">
                      <ul class="ingredient-info edit-shift">
                        <li>
                          <label>Pre-Fill Count Units</label>
                          <div class="input-group select-div span7">
                            <select
                              onChange={(e) =>
                                setGeneralCountSettings({
                                  ...generalCountSettings,
                                  pre_fill_count_unit: e.target.value,
                                })
                              }
                              name="data[InventoryGeneralSetting][pre_fill_count_unit]"
                              id="InventoryGeneralSettingPreFillCountUnit"
                            >
                              {InventoryCountSettingData?.yes_no?.map((el) => (
                                <option
                                  selected={
                                    generalCountSettings?.pre_fill_count_unit ===
                                    el?.value
                                  }
                                  value={el.value}
                                >
                                  {el.label}
                                </option>
                              ))}
                            </select>{" "}
                          </div>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="row mx-0">
              <div class="container px-0 d-flex col-12">
                <div class="btns col-4 d-flex justify-content-end py-4 col-12">
                  <button
                    onClick={() => {
                      dispatch(
                        actions.postGeneralCountSettings(generalCountSettings)
                      );
                    }}
                    id=""
                    type="Submit"
                  >
                    Save
                  </button>
                  <button id="cancel" type="button">
                    Cancel
                  </button>
                </div>
              </div>
            </div>

            <div className="row employeeSettingSec d-flex">
              <div className="col-md-12">
                <div className="shadowclass d-flex flex-wrap align-content-start">
                  <h4 className="event-alert w-100">Count Settings</h4>

                  <div class="col-md-4">
                    <div class="search-box mt-0">
                      <form type="GET">
                        <input
                          type="text"
                          placeholder="Search"
                          name="keyword1"
                        />
                        <input type="submit" />
                      </form>
                    </div>
                  </div>
                  <div class="table-responsive">
                    <table class="checklist-table remove-space inventory_table">
                      <thead>
                        <tr>
                          <th class="first-col col-2">Count Name </th>
                          <th className="col-2">Frequency</th>
                          <th>Categories</th>
                          <th>Scheduled?</th>
                          <th> Actions </th>
                        </tr>
                      </thead>
                      <tbody>
                        {InventoryCountSettingData?.inventoryCountSettings?.map(
                          (el) => (
                            <tr>
                              <td>{el?.count_name}</td>
                              <td>{el?.count_name} </td>
                              <td>
                                {el?.inventory_item_category
                                  ?.map((el) => el?.name)
                                  .join("; ")}
                              </td>
                              <td>{el?.scheduled === 1 ? "Yes" : "No"}</td>
                              <td>
                                <p
                                  onClick={() => {
                                    dispatch(
                                      actions?.getEditInventoryCountSettingsData(
                                        { id: el.id }
                                      )
                                    );
                                    setShowModal(true);
                                    setModalType("edit");
                                  }}
                                  class="editCount circle_icon"
                                >
                                  <i class="iconSprites edit-icon"></i>
                                </p>
                                <p
                                  onClick={() =>
                                    dispatch(
                                      actions.deleteInventoryCountSettingsData({
                                        id: el.id,
                                      })
                                    )
                                  }
                                  class="deleteCount circle_icon red"
                                >
                                  <i class="iconSprites delete-icon"></i>
                                </p>
                              </td>
                            </tr>
                          )
                        )}{" "}
                      </tbody>
                    </table>
                    <div class="my-3">
                      <button
                        onClick={() => {
                          setShowModal(true);
                          setModalType("add");
                        }}
                        class="btn green-btn-revert add-plus"
                        id="addCount"
                        type="button"
                      >
                        <i class="i-icon"> </i> Add Count
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddItemsModal
        showAddModal={showAddModal}
        setShowModal={setShowModal}
        InventoryCountSettingData={InventoryCountSettingData}
        InventoryEditCountSettingData={InventoryEditCountSettingData}
        modalType={modalType}
      />
    </UserInterface>
  );
};

const AddItemsModal = ({
  showAddModal,
  setShowModal,
  InventoryCountSettingData,
  InventoryEditCountSettingData,
  modalType,
}) => {
  const [categories, setCategories] = useState("");
  const [frequency, setFrequency] = useState("");
  const [weekly, setWeekly] = useState("");
  const [timeVal, setTimeVal] = useState("1:10");

  const dispatch = useDispatch();
  useEffect(() => {
    setValue("time", "1:10");
  }, []);

  const editItemModalDefaultState = {
    count_name: InventoryEditCountSettingData?.count_name,
    recurrence: InventoryEditCountSettingData?.recurrence,
    [InventoryEditCountSettingData?.recurrence]:
      !!InventoryEditCountSettingData === true
        ? InventoryEditCountSettingData[
            InventoryEditCountSettingData?.recurrence
          ]
        : "",
    scheduled: InventoryEditCountSettingData?.scheduled === 1 ? "yes" : "no",
    time: InventoryEditCountSettingData?.time,
    inventory_item_category:
      InventoryEditCountSettingData?.inventory_item_category?.map(
        (el) => el.id
      ),
  };
  useEffect(() => {
    if (modalType === "add") {
      itemFormReset(addItemModalDefaultState);
      setTimeVal("4:20");
      setFrequency("");
      setCategories("");
      setWeekly("");
    } else {
      itemFormReset(editItemModalDefaultState);

      setTimeVal(editItemModalDefaultState?.time);
      setFrequency(editItemModalDefaultState?.recurrence);

      setCategories(
        editMultiSelectOptions(
          InventoryCountSettingData?.inventoryItemCategories,
          editItemModalDefaultState?.inventory_item_category
        )
      );

      setWeekly(
        editMultiSelectOptions(
          InventoryCountSettingData?.weekly,
          editItemModalDefaultState?.weekly
        )
      );
    }
  }, [InventoryEditCountSettingData, modalType]);

  console.log(editItemModalDefaultState, "ababababababa");
  const addItemModalDefaultState = {
    count_name: "",
    recurrence: "",
    scheduled: "",
    time: "",
    inventory_item_category: "",
  };
  const itemModalSchema = yup.object().shape({
    count_name: yup.string().required(),
    recurrence: yup.string().required(),
    scheduled: yup.string().required(),
    time: yup.string().required(),
    inventory_item_category: yup.array().nullable().required(),
    [frequency]:
      frequency === "weekly"
        ? yup.array().nullable().required()
        : yup.string().required(),
  });
  const submitData = (data) => {
    let finalData = { ...data, scheduled: data.scheduled === "yes" ? 1 : 0 };
    ["weekly", "daily", "monthly"].forEach((el) => {
      if (frequency !== el) delete finalData[el];
    });
    console.log(data, "submitData");
    dispatch(actions.postAddInventoryCountSettingsData(finalData));
  };
  const {
    register: itemModalRegister,
    formState: { errors: itemModalError },
    handleSubmit: itemFormSubmit,
    reset: itemFormReset,
    control,
    getValues,
    setValue,
  } = useForm({
    resolver: yupResolver(itemModalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues:
      modalType === "add"
        ? addItemModalDefaultState
        : editItemModalDefaultState,
  });

  return (
    <ModelContainer
      title="Add Items"
      open={showAddModal}
      closeModal={() => setShowModal(!showAddModal)}
      submitModal={itemFormSubmit(submitData)}
    >
      <form>
        <div className="form-list">
          <ul className="px-0">
            {console.log(itemModalError, "itemModalError")}
            <Input
              label={"Count Name"}
              formRegister={itemModalRegister}
              formError={itemModalError}
              formKey="count_name"
              isModal
            />

            <Select
              label={"Frequency"}
              formRegister={itemModalRegister}
              formError={itemModalError}
              formKey="recurrence"
              optionsArray={InventoryCountSettingData?.recurrence}
              isModal
              onChange={(e) => {
                setFrequency(e.target.value);
              }}
            />

            {["daily", "monthly"].includes(frequency) && (
              <Select
                label={
                  InventoryCountSettingData?.recurrence?.find(
                    (el) => el?.value === frequency
                  )?.label
                }
                formRegister={itemModalRegister}
                formError={itemModalError}
                formKey={frequency}
                optionsArray={InventoryCountSettingData?.[frequency]}
                isModal
              />
            )}
            {frequency === "weekly" && (
              <MultiSelect
                label={"Weekly"}
                isModal={true}
                localStateValue={weekly}
                setLocalStateMethod={setWeekly}
                optionsArray={[
                  { value: "", label: "Select All" },
                  ...InventoryCountSettingData?.weekly,
                ]}
                formRegister={itemModalRegister}
                formFieldSetMethod={setValue}
                //  getFieldValues {}
                formKey={frequency}
                formError={itemModalError}
              />
            )}
            {console.log(timeVal, "aaaa")}
            <TimeInput
              label="Time"
              formRegister={itemModalRegister}
              formError={itemModalRegister}
              formKey={"time"}
              timeVal={timeVal}
              setTimeVal={setTimeVal}
              isModal={true}
              setFormField={setValue}
            />

            <Select
              label={"Scheduled?"}
              formRegister={itemModalRegister}
              formError={itemModalError}
              formKey="scheduled"
              optionsArray={InventoryCountSettingData?.yes_no}
              isModal
            />
            {!!InventoryEditCountSettingData === true && (
              <MultiSelect
                label={"Items"}
                isModal={true}
                localStateValue={categories}
                setLocalStateMethod={setCategories}
                optionsArray={[
                  { value: "", label: "Select All" },
                  ...InventoryCountSettingData?.inventoryItemCategories,
                ]}
                formRegister={itemModalRegister}
                formFieldSetMethod={setValue}
                //  getFieldValues {}
                formKey={"inventory_item_category"}
                formError={itemModalError}
              />
            )}
          </ul>
        </div>
      </form>
    </ModelContainer>
  );
};

export default InventoryCountSettings;
